import {
  Button,
  Chip,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@heroui/react";
import { CoolHeading } from "../CoolHeading";
import { useState } from "react";

type Props = {
  selectedRounds: string[];
  setSelectedRounds: (rounds: string[]) => void;
};

export const ROUNDS = ["1", "2", "3", "4", "T"];

export function RoundFilter({ selectedRounds, setSelectedRounds }: Props) {
  return (
    <div className="flex w-full flex-col items-start gap-3 rounded-xl bg-gray-200 px-3 pb-3 pt-1 md:w-fit dark:bg-gray-800">
      <CoolHeading variant="fixed" className="mt-2 text-xs">
        Rounds
      </CoolHeading>
      <div className="flex flex-1 gap-2 self-center">
        {["1", "2", "3", "4", "T"].map((round) => {
          return (
            <RoundPopover
              key={round}
              id={round}
              round={round}
              selectedRounds={selectedRounds}
              setSelectedRounds={setSelectedRounds}
            />
          );
        })}
      </div>
    </div>
  );
}

function RoundPopover({ id, round, selectedRounds, setSelectedRounds }) {
  const [popoverOpen, setPopoverOpen] = useState(false);

  function handleRemoveItem(id: string) {
    const newSelectedRounds = selectedRounds.filter((r) => r !== id);
    setSelectedRounds(newSelectedRounds);
  }

  function filterToOnly(id: string) {
    setSelectedRounds([id]);
  }

  function addRoundToSelection(id: string) {
    const newSelectedRounds = [...selectedRounds, id];
    setSelectedRounds(newSelectedRounds);
  }

  const roundSelected = selectedRounds && selectedRounds.includes(id);

  if (roundSelected) {
    return (
      <Popover
        classNames={{
          content: "p-4",
        }}
        isOpen={popoverOpen}
        onOpenChange={setPopoverOpen}
      >
        <PopoverTrigger>
          <Chip
            key={id}
            classNames={{
              base: `${roundSelected ? "text-white bg-primary" : "bg-gray-300/60 dark:bg-gray-700"} rounded-lg min-w-0 px-8 py-4`,
            }}
          >
            {round}
          </Chip>
        </PopoverTrigger>
        <PopoverContent className="flex flex-row gap-4">
          <Button
            color="danger"
            onPress={() => {
              setPopoverOpen(false);
              handleRemoveItem(id);
            }}
          >
            Remove
          </Button>
          <Button
            color="primary"
            onPress={() => {
              setPopoverOpen(false);
              filterToOnly(id);
            }}
          >
            Only Round {round}
          </Button>
        </PopoverContent>
      </Popover>
    );
  } else {
    return (
      <Chip
        as={Button}
        key={id}
        classNames={{
          base: `${roundSelected ? "bg-primary text-white" : "bg-gray-300/60 dark:bg-gray-700"} rounded-lg min-w-0 px-8 py-4 cursor-pointer hover:bg-gray-400/70 dark:hover:bg-gray-600`,
        }}
        onPress={() => addRoundToSelection(id)}
      >
        {round}
      </Chip>
    );
  }
}
